import { ref, onUnmounted } from 'vue'
import { useToast } from '@/composables/common/useToast'
import store from '@/store'
import { config } from '@/config.js'

export function useDeportistaSanciones(props, base) {
    const toast = useToast()

    // ==================== STATE ====================
    const showAddSancionModal = ref(false)
    const showBorrarSancionModal = ref(false)

    const sancionesFilters = ref({
        search: '',
        pagado: null,
        impuesta: null,
        pagar: null
    })

    // ==================== SEARCH ====================
    let sancionesDebounceTimer = null

    onUnmounted(() => {
        clearTimeout(sancionesDebounceTimer)
    })

    /**
     * Actualiza el texto de búsqueda de sanciones con debounce de 500ms
     */
    function updateSancionesSearch(value) {
        sancionesFilters.value = { ...sancionesFilters.value, search: value }
        clearTimeout(sancionesDebounceTimer)
        sancionesDebounceTimer = setTimeout(() => {
            getSanciones()
        }, 500)
    }

    /**
     * Actualiza un filtro de sanciones y recarga inmediatamente
     */
    function updateSancionesFilter(key, value) {
        sancionesFilters.value = { ...sancionesFilters.value, [key]: value || null }
        getSanciones()
    }

    /**
     * Carga las sanciones del deportista desde el endpoint dedicado
     */
    async function getSanciones() {
        const filters = {}
        Object.keys(sancionesFilters.value).forEach(key => {
            if (sancionesFilters.value[key] !== null && sancionesFilters.value[key] !== '') {
                filters[key] = sancionesFilters.value[key]
            }
        })

        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            filters
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.sanciones'),
                params
            )
            if (base.value) {
                base.value = {
                    ...base.value,
                    sanciones: res.data.data || []
                }
            }
        } catch (error) {
            console.error('Error fetching sanciones:', error)
            toast.error('Error al cargar las sanciones')
        }
    }

    /**
     * Agregar una sanción al deportista
     */
    async function addSancion(data) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            ...data
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.sanciones.crear'),
                params
            )
            toast.success(res.data.message || 'Sanción agregada correctamente')
            await getSanciones()
            showAddSancionModal.value = false
        } catch (error) {
            console.error('Error adding sancion:', error)
            toast.error(error.response?.data?.message || 'Error al agregar la sanción')
        }
    }

    /**
     * Borrar una sanción
     */
    async function borrarSancion(sancion_id) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            sancion_id: sancion_id
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.sanciones.borrar'),
                params
            )
            toast.success(res.data.message || 'Sanción eliminada correctamente')
            await getSanciones()
            showBorrarSancionModal.value = false
        } catch (error) {
            console.error('Error deleting sancion:', error)
            toast.error(error.response?.data?.message || 'Error al eliminar la sanción')
        }
    }

    return {
        showAddSancionModal,
        showBorrarSancionModal,
        sancionesFilters,
        updateSancionesSearch,
        updateSancionesFilter,
        getSanciones,
        addSancion,
        borrarSancion,
    }
}
